import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-11",
  "use": "menu-11-usage",
  "viewBox": "0 0 130 103",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130 103\" id=\"menu-11\"><title>资源 109</title><g data-name=\"图层 2\"><g data-name=\"图层 1\"><path d=\"M109 84.33h-9c-3.44 0-6.2-2.45-6.2-4.9V21.9a7.27 7.27 0 0 1 6.89-4.9h9c2.76 0 5.51 2.45 5.51 4.9v56.92c.02 3.06-2.73 5.51-6.2 5.51zm-41.31 0h-8.27c-3.44 0-6.2-3.37-6.2-7.87V7.87C53.22 3.37 56 0 59.42 0h9c2.76 0 5.51 3.37 5.51 7.87V77c0 3.94-2.76 7.31-6.2 7.31zm-49.6 0c-3.44 0-6.2-.88-6.2-2.21V51.21c0-1.33 2.76-2.21 6.2-2.21h9a13.86 13.86 0 0 1 4.13.88c.69.44 1.38.88 1.38 1.33v30.47c0 1.77-2.76 2.65-6.2 2.65h-8.31z\" /><rect y=\"93\" width=\"130\" height=\"10\" rx=\"5\" ry=\"5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-11.svg
// module id = 27Ve
// module chunks = 6